module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('my-cell-header', {
    attrs: {
      "cellHeader": "自然人"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "普通投资者",
      "is-link": ""
    },
    on: {
      "click": _vm.perNor
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "专业投资者",
      "is-link": ""
    },
    on: {
      "click": _vm.perPro
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "从业人员",
      "is-link": ""
    },
    on: {
      "click": _vm.perEmp
    }
  })], 1)], 1), _vm._v(" "), _c('my-cell-header', {
    attrs: {
      "cellHeader": "机构"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "普通投资者",
      "is-link": ""
    },
    on: {
      "click": _vm.orgNor
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "专业投资者（法人及其他组织）",
      "is-link": ""
    },
    on: {
      "click": _vm.orgPro
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "金融机构",
      "is-link": ""
    },
    on: {
      "click": _vm.orgFin
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "本机构",
      "is-link": ""
    },
    on: {
      "click": _vm.orgSelf
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bcaad7c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/Confirm/confirmListGuide.vue
// module id = 1046
// module chunks = 1